module.exports = __webpack_public_path__ + "static/media/card-design-happy-anniversary.1aa4e117.png";